import React from "react"
import { Button, Heading, HStack, Text, VStack } from "@chakra-ui/react"
import GradientBox from "./GradientBox"
import AccountLayout from "./AccountLayout"
import Message from "./Message"
import { useNavigate } from "react-router-dom"

export default function PageNotFound() {
  const navigate = useNavigate()

  const gradientBox = (
    <GradientBox>
      <VStack justifyContent="flex-start" alignItems="flex-start">
        <Heading color="white">404 - Not Found</Heading>
        <Text color="white">
          Oops! The page you are looking for does not exist.
        </Text>
        <HStack mt="1em" flex="wrap" width="100%">
          <Button variant="account" onClick={() => navigate(-1)}>
            Go Back
          </Button>
          <Button variant="account" onClick={() => navigate("/")}>
            Home
          </Button>
        </HStack>
      </VStack>
      <span />
    </GradientBox>
  )

  const message = <Message />

  return <AccountLayout gradientBox={gradientBox} message={message} />
}
